var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M0 0L0 1000L1000 1000L1000 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M455 95L455 96L468 96L455 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M468 95L468 96L476 96L468 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M476 95L476 96L491 96L476 95M438 96L438 97L442 97L438 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M442 96L442 97L445 97L442 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M445 96L445 97L449 97L445 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M313 886L449 844.025L695 768C690.825 753.536 680.47 739.242 673.309 726C660.746 702.771 648.941 679.095 636.139 656C629.218 643.515 617.409 627.958 614.39 614C610.218 594.706 622.245 573.654 625 555L626 555C625.66 571.496 622.446 587.516 625.424 604C633.431 648.314 669.656 689.744 707 713C701.129 692.62 687.185 676.328 687 654L688 654C695.634 673.845 722.037 698.029 741 707C734.967 696.164 727.519 686.349 722.309 675C708.582 645.101 702 613.819 702 581L703 581C712.821 620.866 739.644 655.157 783 661C777.283 647.477 767.236 635.947 761.604 622C748.06 588.459 745.863 551.54 750.285 516C753.51 490.076 761.312 465.257 767.627 440C778.31 397.266 788.878 354.485 796.08 311C801.656 277.337 807.146 240.184 796.33 207C779.126 154.217 725.882 130.509 673 139.326C662.57 141.065 651.858 146.074 642 149.808C638.193 151.25 632.134 154.72 628 154.018C621.122 152.849 614.189 141.812 609 137.439C596.246 126.692 581.434 117.906 566 111.603C513.073 89.9892 453.464 93.5544 398 101.728C377.2 104.794 356.628 113.618 336 115.826C315.906 117.978 286.425 106.938 274.919 131C271.349 138.465 269.689 148.872 271.529 157C273.091 163.906 278.187 169.554 275.401 177C271.714 186.855 261.253 195.324 256.258 205C243.925 228.893 237.711 255.317 235.17 282C234.112 293.106 232.519 305.897 234.213 317C235.834 327.627 242.947 334.485 239.215 346C232.232 367.543 213.78 388.33 201.333 407C196.828 413.758 186.482 423.515 187.123 432C187.848 441.593 201.143 452.612 210 454.864C216.631 456.551 225.146 453.971 227.797 462.831C229.191 467.489 226.597 479.807 224.351 484C222.232 487.957 217.856 492.014 218.838 496.957C220.255 504.086 230.924 503.546 232.522 511.004C234.147 518.586 222.489 524.136 227.746 531.892C233.7 540.674 245.443 540.891 247.377 554C249.534 568.614 237.149 580.115 247.789 594.999C256.175 606.73 269.612 609.021 283 609C306.763 608.962 332.642 597.661 356 602.095C370.062 604.764 378.266 615.214 384.999 627C398.404 650.466 408.035 677.447 416.667 703C420.456 714.216 426.2 725.878 425.946 738C425.882 741.07 425.246 744.171 424.045 747C415.095 768.069 392.566 749.124 381.653 764.044C374.01 774.493 381.214 790.973 373.881 803C361.495 823.315 344.905 841.962 330.627 861C324.73 868.863 316.836 876.927 313 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M502 96L502 97L505 97L502 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M505.667 96.3333L506.333 96.6667L505.667 96.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M507 96L507 97L510 97L507 96M426 97L426 98L429 98L426 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M429.667 97.3333L430.333 97.6667L429.667 97.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M431 97L431 98L434 98L431 97M513 97L514 98L513 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M514.667 97.3333L515.333 97.6667L514.667 97.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M516.667 97.3333L517.333 97.6667L516.667 97.3333M416 98L416 99L419 99L416 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M419.667 98.3333L420.333 98.6667L419.667 98.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M421.667 98.3333L422.333 98.6667L421.667 98.3333M520 98L521 99L520 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M521 98L522 99L521 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M522.667 98.3333L523.333 98.6667L522.667 98.3333M408 99L408 100L411 100L408 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M411.667 99.3333L412.333 99.6667L411.667 99.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M413 99L414 100L413 99M525 99L526 100L525 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M526 99L527 100L526 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M527.667 99.3333L528.333 99.6667L527.667 99.3333M402.667 100.333L403.333 100.667L402.667 100.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M404 100L405 101L404 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M405 100L406 101L405 100M530 100L531 101L530 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M531 100L532 101L531 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M532 100L533 101L532 100M395.667 101.333L396.333 101.667L395.667 101.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M397 101L398 102L397 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M398.667 101.333L399.333 101.667L398.667 101.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M535 101L536 102L535 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M536 101L537 102L536 101M389.667 102.333L390.333 102.667L389.667 102.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M391 102L392 103L391 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M392 102L393 103L392 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M539 102L540 103L539 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M540 102L541 103L540 102M384 103L385 104L384 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M385.667 103.333L386.333 103.667L385.667 103.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M387 103L388 104L387 103M542 103L543 104L542 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M543 103L544 104L543 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M544 103L545 104L544 103M379 104L380 105L379 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M380.667 104.333L381.333 104.667L380.667 104.333M546 104L547 105L546 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M547 104L548 105L547 104M374 105L375 106L374 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M375.667 105.333L376.333 105.667L375.667 105.333M549 105L550 106L549 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M550 105L551 106L550 105M370 106L371 107L370 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M371 106L372 107L371 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M372 106L373 107L372 106M552 106L553 107L552 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M553 106L554 107L553 106M365.667 107.333L366.333 107.667L365.667 107.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M367 107L368 108L367 107M555 107L556 108L555 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M556 107L557 108L556 107M361 108L362 109L361 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M362 108L363 109L362 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M363 108L364 109L363 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M558 108L559 109L558 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M559 108L560 109L559 108M357.667 109.333L358.333 109.667L357.667 109.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M359 109L360 110L359 109M560 109L561 110L560 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M561 109L562 110L561 109M354 110L355 111L354 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M355 110L356 111L355 110M563 110L564 111L563 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M564 110L565 111L564 110M350 111L351 112L350 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M351 111L352 112L351 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M352 111L353 112L352 111M565 111L566 112L565 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M566 111L567 112L566 111M347 112L348 113L347 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M348 112L349 113L348 112M568 112L569 113L568 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M344 113L345 114L344 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M345 113L346 114L345 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M570 113L571 114L570 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M571 113L572 114L571 113M297 114L297 115L301 115L297 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M301.667 114.333L302.333 114.667L301.667 114.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M303 114L303 115L317 115L303 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M317 114L317 115L322 115L317 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M322 114L322 115L327 115L322 114M340 114L341 115L340 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M341 114L342 115L341 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M342 114L343 115L342 114M572 114L573 115L572 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M573 114L574 115L573 114M292 115L292 116L295 116L292 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M295 115L296 116L295 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M296.667 115.333L297.333 115.667L296.667 115.333M326.667 115.333L327.333 115.667L326.667 115.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M328.667 115.333L329.333 115.667L328.667 115.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M330 115L330 116L334 116L330 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M334 115L334 116L337 116L334 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M337.667 115.333L338.333 115.667L337.667 115.333M574 115L575 116L574 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M575 115L576 116L575 115M289.667 116.333L290.333 116.667L289.667 116.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M291 116L292 117L291 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M292 116L293 117L292 116M576 116L577 117L576 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M577 116L578 117L577 116M287 117L288 118L287 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M288 117L289 118L288 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M289 117L290 118L289 117M578 117L579 118L578 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M579 117L580 118L579 117M285 118L284 120L285 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M286 118L287 119L286 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M287 118L288 119L287 118M301.667 118.333L302.333 118.667L301.667 118.333M580 118L581 119L580 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M581 118L582 119L581 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M285 119L286 120L285 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M582 119L583 120L582 119M283 120L284 121L283 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M284 120L285 121L284 120M311 120L311 121L327 122L311 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M584 120L585 121L584 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M281 121L276 127L281 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M282 121L283 122L282 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M302.667 121.333L303.333 121.667L302.667 121.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M304.667 121.333L305.333 121.667L304.667 121.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M306 121L306 122L316 122L306 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M276 148L325 122C320.483 120.105 315.733 121.746 311 121.961C294.349 122.716 276.178 128.054 276 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M325 121L326 122L325 121M586 121L587 122L586 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M281 122L282 123L281 122M298 122L299 123L298 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M299.667 122.333L300.333 122.667L299.667 122.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M301.667 122.333L302.333 122.667L301.667 122.333M324 122L325 123L324 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M587 122L588 123L587 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M588 122L589 123L588 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M280 123L281 124L280 123M293 123L294 124L293 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M294 123L295 124L294 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M295 123L295 124L298 124L295 123M317 123L318 124L317 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M318 123L319 124L318 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M319 123L320 124L319 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M589 123L590 124L589 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M279 124L280 125L279 124M290 124L291 125L290 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M291 124L292 125L291 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M292 124L293 125L292 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M314 124L315 125L314 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M315 124L316 125L315 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M591 124L592 125L591 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M278 125L279 126L278 125M288 125L289 126L288 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M289 125L290 126L289 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M312 125L313 126L312 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M592 125L593 126L592 125M277 126L278 127L277 126M286 126L285 128L286 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M287 126L288 127L287 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M288 126L289 127L288 126M310 126L311 127L310 126M594 126L595 127L594 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M276 127L277 128L276 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M286 127L287 128L286 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M309 127L310 128L309 127M595 127L596 128L595 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M275 128L274 131L275 131L275 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M284 128L285 129L284 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M307 128L308 129L307 128M597 128L598 129L597 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M275 129L276 130L275 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M283 129L284 130L283 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M306 129L307 130L306 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M598 129L599 130L598 129M282 130L283 131L282 130M305 130L306 131L305 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M599 130L600 131L599 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M600 130L601 131L600 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M274 131L275 132L274 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M281 131L282 132L281 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M304 131L305 132L304 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M601 131L602 132L601 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M273 132L274 133L273 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M280 132L279 134L280 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M281 132L282 133L281 132M302 132L303 133L302 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M602 132L603 133L602 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M273 133L274 134L273 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M280 133L281 134L280 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M301 133L302 134L301 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M604 133L605 134L604 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M273 134L274 135L273 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M279 134L280 135L279 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M300 134L301 135L300 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M605 134L606 135L605 134M272.333 135.667L272.667 136.333L272.333 135.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M278 135L279 136L278 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M279 135L280 136L279 135M298 135L299 136L298 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M606 135L607 136L606 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M278 136L279 137L278 136M297 136L298 137L297 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M607 136L608 137L607 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M272 137L273 138L272 137M277 137L278 138L277 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M296 137L297 138L296 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M609 137L610 138L609 137M689 137L689 138L700 138L689 137M271.333 138.667L271.667 139.333L271.333 138.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M272 138L273 139L272 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M277 138L278 139L277 138M294 138L295 139L294 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M295 138L296 139L295 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M610 138L611 139L610 138M675 138L675 139L678 139L675 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M678 138L678 139L681 139L678 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M681 138L681 139L684 139L681 138M705.667 138.333L706.333 138.667L705.667 138.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M707 138L707 139L710 139L707 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M710 138L710 139L713 139L710 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M276 139L277 140L276 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M293 139L294 140L293 139M611 139L612 140L611 139M670 139L671 140L670 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 139L672 140L671 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M715 139L716 140L715 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M716.667 139.333L717.333 139.667L716.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M718.667 139.333L719.333 139.667L718.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M271.333 140.667L271.667 141.333L271.333 140.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M276 140L277 141L276 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M292 140L293 141L292 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M612 140L613 141L612 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M667 140L668 141L667 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M668 140L669 141L668 140M721 140L722 141L721 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M722 140L723 141L722 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M723.667 140.333L724.333 140.667L723.667 140.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M275 141L276 142L275 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M290 141L291 142L290 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M291 141L292 142L291 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M613 141L614 142L613 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M664 141L665 142L664 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M665 141L666 142L665 141M726 141L727 142L726 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M727 141L728 142L727 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M728 141L729 142L728 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M271 142L272 143L271 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M275 142L276 143L275 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M289 142L290 143L289 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M614 142L615 143L614 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M661 142L662 143L661 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M662 142L663 143L662 142M730 142L731 143L730 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M731.667 142.333L732.333 142.667L731.667 142.333M270 143L270 147L271 147L270 143M275 143L275 149L276 149L275 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M288 143L289 144L288 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M615 143L616 144L615 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M658 143L659 144L658 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M659 143L660 144L659 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M733 143L734 144L733 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M734 143L735 144L734 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M735 143L736 144L735 143M286 144L287 145L286 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M287 144L288 145L287 144M616 144L617 145L616 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M655 144L656 145L655 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M656 144L657 145L656 144M737 144L738 145L737 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M738 144L739 145L738 144M280 145L281 146L280 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M281.667 145.333L282.333 145.667L281.667 145.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M283 145L284 146L283 145M617 145L618 146L617 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M652 145L653 146L652 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M653 145L654 146L653 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M739 145L740 146L739 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M740 145L741 146L740 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M278 146L279 147L278 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M618 146L619 147L618 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M650 146L651 147L650 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M651 146L652 147L651 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M742 146L743 147L742 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M743 146L744 147L743 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M270 147L270 154L271 154L270 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M277 147L278 148L277 147M619 147L620 148L619 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M647 147L648 148L647 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M648 147L649 148L648 147M744 147L745 148L744 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M745 147L746 148L745 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M276 148L277 149L276 148M620 148L621 149L620 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M644 148L645 149L644 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M645 148L646 149L645 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M746 148L747 149L746 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M747 148L748 149L747 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M275 149L276 150L275 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M621 149L622 150L621 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M641 149L642 150L641 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M642 149L643 150L642 149M749 149L750 150L749 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M275 150L276 151L275 150M622 150L623 151L622 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M638 150L639 151L638 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M639 150L640 151L639 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M640 150L641 151L640 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M751 150L752 151L751 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M623 151L624 152L623 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M636 151L637 152L636 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M637 151L638 152L637 151M752 151L753 152L752 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M753 151L754 152L753 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M624 152L625 153L624 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 152L634 153L633 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M634 152L635 153L634 152M754 152L755 153L754 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M755 152L756 153L755 152M625 153L626 154L625 153M630 153L631 154L630 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M631 153L632 154L631 153M756 153L757 154L756 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M270 154L270 157L271 157L270 154M626 154L627 155L626 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M628 154L629 155L628 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M629 154L630 155L629 154M757 154L758 155L757 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M758 154L759 155L758 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M759 155L760 156L759 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M760 156L761 157L760 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M761 156L762 157L761 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M271 157L272 158L271 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M762 157L763 158L762 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M271 158L272 159L271 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M763 158L764 159L763 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M271 159L272 160L271 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M764 159L765 160L764 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M765 159L766 160L765 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M272 160L273 161L272 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M766 160L767 161L766 160M272.333 161.667L272.667 162.333L272.333 161.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M767 161L768 162L767 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M273 162L274 163L273 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M768 162L769 163L768 162M273 163L274 164L273 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M769 163L770 164L769 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M273 164L274 165L273 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M770 164L771 165L770 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M274 165L275 166L274 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M771 165L772 166L771 165M275 166L276 167L275 166M772 166L773 167L772 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M275 167L276 168L275 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M773 167L774 168L773 167M276 168L276 171L277 171L276 168M774 168L775 169L774 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M775 169L776 170L775 169M776 170L777 171L776 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M777 171L778 172L777 171M778 172L779 173L778 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M779 174L780 175L779 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M780 175L781 176L780 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M781 176L782 177L781 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M275 178L276 179L275 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M782 178L783 179L782 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M274 179L275 180L274 179M783 179L784 180L783 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M273 180L274 181L273 180M784 180L785 181L784 180M272 181L273 182L272 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M784 181L785 182L784 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M271 182L272 183L271 182M785 182L786 183L785 182M270 183L271 184L270 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M786 184L787 185L786 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M269 185L270 186L269 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M787 185L788 186L787 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M268 186L269 187L268 186M787 186L788 187L787 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M267 187L268 188L267 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M788 187L789 188L788 187M266 188L267 189L266 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M788 188L789 189L788 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M265 189L266 190L265 189M789 189L790 190L789 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M265 190L266 191L265 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M264 191L265 192L264 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M790 191L791 192L790 191M263 192L264 193L263 192M791 193L792 194L791 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M262 194L263 195L262 194M791 194L792 195L791 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M261 195L262 196L261 195M792 195L793 196L792 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M792 196L793 197L792 196M260 197L261 198L260 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M793 197L794 198L793 197M259 198L260 199L259 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M793 198L794 199L793 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M259 199L260 200L259 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M258 200L259 201L258 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M794 200L795 201L794 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M794 201L795 202L794 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M257 202L258 203L257 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M256 203L257 204L256 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M795 203L796 204L795 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M256 204L257 205L256 204M795 204L796 205L795 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M255 205L256 206L255 205M796 205L797 206L796 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M255 206L256 207L255 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M796 206L797 207L796 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M254 207L255 208L254 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M796 207L797 208L796 207M254 208L255 209L254 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M253 209L254 210L253 209M797 209L798 210L797 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M253 210L254 211L253 210M797 210L798 211L797 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M252 211L253 212L252 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M252 212L253 213L252 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M798 212L799 213L798 212M251 213L252 214L251 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M798 213L799 214L798 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M251 214L252 215L251 214M798 214L799 215L798 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M250 215L251 216L250 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M250 216L251 217L250 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M799 216L800 217L799 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M799 217L800 218L799 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M249 218L250 219L249 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M799 218L800 219L799 218M249 219L250 220L249 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M248 220L249 221L248 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M248 221L249 222L248 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M674 221L678 224L678 223L674 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M800 221L801 222L800 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M800.333 222.667L800.667 223.333L800.333 222.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M247 223L248 224L247 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M247 224L248 225L247 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M663 224L664 225L663 224M677 224L679 226L679 224L677 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M800 224L801 225L800 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M663 225L664 226L663 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M664 225L665 226L664 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M679 225L683 229L679 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M246 226L247 227L246 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M663 226C677.581 263.799 686.218 308.444 673.974 348C663.907 380.524 647.326 410.969 629.796 440C618.228 459.157 604.255 477.312 597.721 499C587.417 533.206 592.695 566.57 606 599L607 599C610.944 568.459 623.217 540.507 633.935 512C641.218 492.628 646.627 472.91 655.309 454C668.311 425.679 683.569 397.254 688.675 366C690.808 352.943 689 338.228 689 325C689 298.28 686.562 274.84 676 250C672.63 242.074 669.189 232.124 663 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M664 226L665 227L664 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M246 227L247 228L246 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M663 227L664 228L663 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M665 227L666 228L665 227M682 227L683 228L682 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M801.333 227.667L801.667 228.333L801.333 227.667M245 228L246 229L245 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M663 228L664 229L663 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 228L666 229L665 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M681 228L682 229L681 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M683 228L687 232L683 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M245 229L246 230L245 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M664 229L665 230L664 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M666 229L667 230L666 229M674 229L675 230L674 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M682 229L683 230L682 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M683 229L698 254L699 254C696.373 244.882 690.571 234.807 683 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M801.333 229.667L801.667 230.333L801.333 229.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M245 230L246 231L245 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M664 230L665 231L664 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M666 230L667 231L666 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M675 230L676 233L677 233L675 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M683 230L685 232L683 230M244 231L245 232L244 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M664 231L665 232L664 231M667 231L668 232L667 231M675 231L676 232L675 231M683 231L684 232L683 231M801.333 231.667L801.667 232.333L801.333 231.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M244 232L245 233L244 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 232L666 233L665 232M667 232L668 233L667 232M677 232L677 234L679 234L677 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M684 232L685 233L684 232M244 233L245 234L244 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M665 233L666 234L665 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M668 233L669 234L668 233M676 233L677 234L676 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M685 233L686 234L685 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M687 233L688 234L687 233M668 234L669 235L668 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M677 234L678 235L677 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M678 234L695.536 285L697 333L698 333C699.411 326.162 702.467 318.988 702.737 312C702.978 305.756 700.997 299.164 700.13 293C697.31 272.943 694.041 248.239 678 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M679 234L680 235L679 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M686 234L689 237L686 234M688 234L689 235L688 234M243 235L244 236L243 235M666 235L667 236L666 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M669 235L670 236L669 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M678 235L679 236L678 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M680 235L681 236L680 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M686 235L687 236L686 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M689 235L690 236L689 235M243 236L244 237L243 236M666 236L667 237L666 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M669 236L670 237L669 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M678 236L679 237L678 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M680 236L682 238L680 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M681 236L682 237L681 236M687 236L688 237L687 236M690 236L691 237L690 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M670 237L671 238L670 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M679 237L680 238L679 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M688 237L689 238L688 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M690 237L691 238L690 237M242 238L243 239L242 238M667 238L668 239L667 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M671 238L672 239L671 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M679 238L680 239L679 238M682 238L683 239L682 238M689 238L690 239L689 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M691 238L692 239L691 238M802 238L802 242L803 242L802 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M242 239L243 240L242 239M667 239L668 240L667 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M671 239L672 240L671 239M680 239L681 240L680 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M683 239L684 240L683 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M690 239L691 240L690 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M692 239L693 240L692 239M242 240L243 241L242 240M667 240L668 241L667 240M672 240L673 241L672 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M680 240L681 241L680 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M683 240L685 242L683 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M684 240L685 241L684 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M690 240L691 241L690 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M668 241L669 242L668 241M672 241L673 242L672 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M680 241L681 242L680 241M685 241L686 242L685 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M691 241L692 242L691 241M693 241L694 242L693 241M241 242L242 243L241 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M668 242L669 243L668 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M673 242L674 243L673 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M681 242L682 243L681 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M685 242L686 243L685 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M691 242L692 243L691 242M694 242L695 243L694 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M802 242L802 248L803 248L802 242M241 243L242 244L241 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M668 243L669 244L668 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M673 243L674 244L673 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M681 243L682 244L681 243M686 243L687 244L686 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M692 243L693 244L692 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694 243L695 244L694 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M241 244L242 245L241 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M673 244L674 245L673 244M682 244L683 245L682 244M686 244L687 245L686 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M692 244L693 245L692 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M693 244L694 245L693 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M695 244L696 245L695 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M669 245L670 246L669 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M674 245L675 246L674 245M682 245L683 246L682 245M687 245L688 246L687 245M693 245L694 246L693 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M695 245L696 246L695 245M240 246L241 247L240 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M669 246L670 247L669 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M674 246L675 247L674 246M683 246L684 247L683 246M687 246L688 247L687 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M688 246L689 247L688 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694 246L695 247L694 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M696 246L697 247L696 246M240 247L241 248L240 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M675 247L676 248L675 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M683 247L684 248L683 247M688 247L689 248L688 247M694 247L695 248L694 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M696 247L697 248L696 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M240 248L241 249L240 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M670 248L671 249L670 248M675 248L676 249L675 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M683 248L684 249L683 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M684 248L685 249L684 248M688 248L689 249L688 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M689 248L690 249L689 248M694 248L695 249L694 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M695 248L696 249L695 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M697 248L698 249L697 248M802 248L802 252L803 252L802 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M670 249L671 250L670 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M676 249L677 250L676 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M684 249L685 250L684 249M689 249L690 250L689 249M695 249L696 250L695 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M697 249L698 250L697 249M239.333 250.667L239.667 251.333L239.333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M670 250L671 251L670 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M676.333 250.667L676.667 251.333L676.333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M684 250L685 251L684 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M689 250L690 251L689 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M690 250L691 251L690 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M696 250L697 251L696 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M698 250L699 251L698 250M677 251L678 252L677 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M685 251L686 252L685 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M690 251L691 252L690 251M696 251L697 252L696 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M698 251L699 252L698 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M239 252L240 253L239 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M671 252L672 253L671 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M677 252L678 253L677 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M685 252L686 253L685 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M690 252L691 253L690 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M691 252L692 253L691 252M696 252L697 253L696 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M697 252L698 253L697 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M802 252L802 260L803 260L802 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M239 253L240 254L239 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 253L672 254L671 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M677 253L678 254L677 253M686 253L687 254L686 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M691 253L692 254L691 253M697 253L698 254L697 253M699 253L700 254L699 253M678 254L679 255L678 254M686 254L687 255L686 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M691 254L692 255L691 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M697 254L698 255L697 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M698 254L698 256L700 254L698 254M238 255L239 256L238 255M678 255L679 256L678 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M686 255L687 256L686 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M692 255L693 256L692 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M699 255L703 275L704 275L699 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M700 255L701 256L700 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M238.333 256.667L238.667 257.333L238.333 256.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M672 256L673 257L672 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M679 256L680 257L679 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M687 256L688 257L687 256M692 256L693 257L692 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M698 256L699 257L698 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M700 256L701 257L700 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M672 257L673 258L672 257M679 257L680 258L679 257M687 257L688 258L687 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M693 257L694 258L693 257M698 257L699 258L698 257M238 258L239 259L238 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M679 258L680 259L679 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M687 258L688 259L687 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M688.333 258.667L688.667 259.333L688.333 258.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M693 258L694 259L693 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M699 258L700 259L699 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M701 258L702 259L701 258M680 259L681 260L680 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M693 259L694 260L693 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M699 259L700 260L699 259M701 259L702 260L701 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M237.333 260.667L237.667 261.333L237.333 260.667M673 260L674 261L673 260M680.333 260.667L680.667 261.333L680.333 260.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M688 260L689 261L688 260M694 260L695 261L694 260M699.333 260.667L699.667 261.333L699.333 260.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M701 260L702 261L701 260M802 260L802 265L803 265L802 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M673 261L674 262L673 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M681 261L682 262L681 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M689 261L690 262L689 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M694 261L695 262L694 261M237 262L238 263L237 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M673 262L674 263L673 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M681 262L682 263L681 262M689 262L690 263L689 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694.333 262.667L694.667 263.333L694.333 262.667M700 262L701 263L700 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M702 262L703 263L702 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M237.333 263.667L237.667 264.333L237.333 263.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M681 263L682 264L681 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M689 263L690 264L689 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M700 263L701 264L700 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M702.333 263.667L702.667 264.333L702.333 263.667M674 264L675 265L674 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M682 264L683 265L682 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M690 264L691 265L690 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M695 264L696 265L695 264M700.333 264.667L700.667 265.333L700.333 264.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M674 265L675 266L674 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M682.333 265.667L682.667 266.333L682.333 265.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M690 265L691 266L690 265M695 265L696 266L695 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M674 266L675 267L674 266M690 266L691 267L690 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M695.333 266.667L695.667 267.333L695.333 266.667M701 266L702 267L701 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M703 266L704 267L703 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M236.333 267.667L236.667 268.333L236.333 267.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M683 267L684 268L683 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M691 267L692 268L691 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M701 267L702 268L701 267M703 267L704 268L703 267M683 268L684 269L683 268M691 268L692 269L691 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M696 268L697 269L696 268M701.333 268.667L701.667 269.333L701.333 268.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M703.333 268.667L703.667 269.333L703.333 268.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M236 269L237 270L236 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M675 269L676 270L675 269M683 269L684 270L683 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M691 269L692 270L691 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M696.333 269.667L696.667 270.333L696.333 269.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M801.333 269.667L801.667 270.333L801.333 269.667M236.333 270.667L236.667 271.333L236.333 270.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M675.333 270.667L675.667 271.333L675.333 270.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M684 270L685 271L684 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M692.333 270.667L692.667 271.333L692.333 270.667M702.333 270.667L702.667 271.333L702.333 270.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M684 271L685 272L684 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M696.333 271.667L696.667 272.333L696.333 271.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M704.333 271.667L704.667 272.333L704.333 271.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M801 271L801 274L802 274L801 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M675 272L676 273L675 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M684.333 272.667L684.667 273.333L684.333 272.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M692 272L693 273L692 272M702 272L703 273L702 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M692.333 273.667L692.667 274.333L692.333 273.667M697 273L698 274L697 273M702.333 273.667L702.667 274.333L702.333 273.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M704 273L705 274L704 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M235 274L235 277L236 277L235 274M676.333 274.667L676.667 275.333L676.333 274.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M685 274L686 275L685 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M697 274L698 275L697 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M704 274L704 278L705 278L704 274M801 274L801 277L802 277L801 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M685 275L686 276L685 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M693.333 275.667L693.667 276.333L693.333 275.667M697 275L697 278L698 278L697 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M676 276L677 277L676 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M685.333 276.667L685.667 277.333L685.333 276.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M235.333 277.667L235.667 278.333L235.333 277.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M676 277L677 278L676 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M693 277L694 278L693 277M703 277L704 278L703 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M686.333 278.667L686.667 279.333L686.333 278.667M693.333 278.667L693.667 279.333L693.333 278.667M698 278L699 279L698 278M703.333 278.667L703.667 279.333L703.333 278.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M704.333 278.667L704.667 279.333L704.333 278.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M235 279L236 280L235 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M698 279L699 280L698 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M800.333 279.667L800.667 280.333L800.333 279.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M677 280L677 283L678 283L677 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M686 280L687 281L686 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694 280L695 281L694 280M698 280L698 283L699 283L698 280M704.333 280.667L704.667 281.333L704.333 280.667M686.333 281.667L686.667 282.333L686.333 281.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M694 281L695 282L694 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M705 281L705 290L706 290L705 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M800.333 281.667L800.667 282.333L800.333 281.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M694.333 282.667L694.667 283.333L694.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M704.333 282.667L704.667 283.333L704.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M234 283L234 287L235 287L234 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M677 283L678 284L677 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M687 283L688 284L687 283M699.333 283.667L699.667 284.333L699.333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M800.333 283.667L800.667 284.333L800.333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M677.333 284.667L677.667 285.333L677.333 284.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M687 284L688 285L687 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M695 284L695 287L696 287L695 284M687 285L687 288L688 288L687 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M699 285L700 286L699 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M699 286L699 289L700 289L699 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M234 287L234 291L235 291L234 287M695.333 287.667L695.667 288.333L695.333 287.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M678 288L678 291L679 291L678 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M799 288L800 289L799 288M688 289L688 292L689 292L688 289M695 289L695 292L696 292L695 289M700.333 289.667L700.667 290.333L700.333 289.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M799.333 289.667L799.667 290.333L799.333 289.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M234 291L234 294L235 294L234 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M678 291L678 294L679 294L678 291M700.333 291.667L700.667 292.333L700.333 291.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M799.333 291.667L799.667 292.333L799.333 291.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M688.333 292.667L688.667 293.333L688.333 292.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M696 293L696 296L697 296L696 293M700 293L700 296L701 296L700 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M678.333 294.667L678.667 295.333L678.333 294.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M688 294L688 298L689 298L688 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M798 295L799 296L798 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M696 296L696 299L697 299L696 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M701.333 296.667L701.667 297.333L701.333 296.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M798.333 296.667L798.667 297.333L798.333 296.667M701.333 298.667L701.667 299.333L701.333 298.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M798.333 298.667L798.667 299.333L798.333 298.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M689 299L689 315L690 315L689 299M696 299L696 312L697 312L696 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M701.333 300.667L701.667 301.333L701.333 300.667M679 301L679 315L680 315L679 301M233 302L233 313L234 313L233 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M797 302L798 303L797 302M702.333 303.667L702.667 304.333L702.333 303.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M797.333 303.667L797.667 304.333L797.333 303.667M702 305L703 306L702 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M797.333 305.667L797.667 306.333L797.333 305.667M702 306L702 309L703 309L702 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M796 308L797 309L796 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M796.333 309.667L796.667 310.333L796.333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M796.333 311.667L796.667 312.333L796.333 311.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M696.333 313.667L696.667 314.333L696.333 313.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M702 314L703 315L702 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M795 314L796 315L795 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M689 315L689 363L690 363C690 349.474 694.209 327.414 689 315M702 315L703 316L702 315M795.333 315.667L795.667 316.333L795.333 315.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M702 316L703 317L702 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M795.333 317.667L795.667 318.333L795.333 317.667M701 318L702 319L701 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M234 319L235 320L234 319M701 319L702 320L701 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M678.333 320.667L678.667 321.333L678.333 320.667M701 320L702 321L701 320M794 320L795 321L794 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M235 321L236 322L235 321M794 321L795 322L794 321M678.333 322.667L678.667 323.333L678.333 322.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M700 322L701 323L700 322M794.333 322.667L794.667 323.333L794.333 322.667M236 323L237 324L236 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M700 323L701 324L700 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M678 324L678 327L679 327L678 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M700 324L701 325L700 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M237 325L238 326L237 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M699 326L700 327L699 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M793 326L794 327L793 326M238 327L239 328L238 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M699 327L700 328L699 327M793 327L794 328L793 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M238 328L239 329L238 328M793 328L794 329L793 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M677 329L678 330L677 329M239 330L240 331L239 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M677.333 330.667L677.667 331.333L677.333 330.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M698 330L699 331L698 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M239 331L240 332L239 331M698 331L699 332L698 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M792 331L793 332L792 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M239.333 332.667L239.667 333.333L239.333 332.667M677.333 332.667L677.667 333.333L677.333 332.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M792 332L793 333L792 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M697 333L698 334L697 333M792.333 333.667L792.667 334.333L792.333 333.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M697 334L698 335L697 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M676 335L677 336L676 335M697 335L698 336L697 335M240 336L240 341L241 341L240 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M676 336L677 337L676 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M791 336L792 337L791 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M676.333 337.667L676.667 338.333L676.333 337.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M791 337L792 338L791 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M791.333 338.667L791.667 339.333L791.333 338.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M675 340L676 341L675 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M675 341L676 342L675 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M790 341L791 342L790 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M675 342L676 343L675 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M790 342L791 343L790 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M239.333 343.667L239.667 344.333L239.333 343.667M790.333 343.667L790.667 344.333L790.333 343.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M674 344L675 345L674 344M239 345L240 346L239 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M674 345L675 346L674 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M674 346L675 347L674 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M789 346L790 347L789 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M238 347L239 348L238 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M789 347L790 348L789 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M238 348L239 349L238 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M673 348L674 349L673 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M789.333 348.667L789.667 349.333L789.333 348.667M237 349L238 350L237 349M673 349L674 350L673 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M237 350L238 351L237 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M236 351L237 352L236 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M672 351L673 352L672 351M788 351L789 352L788 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M672 352L673 353L672 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M788 352L789 353L788 352M235 353L236 354L235 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M788 353L789 354L788 353M234 354L235 355L234 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 354L672 355L671 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M234 355L235 356L234 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M671 355L672 356L671 355M233 356L234 357L233 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M787 356L788 357L787 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M670 357L671 358L670 357M787 357L788 358L787 357M232 358L233 359L232 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M670 358L671 359L670 358M787 358L788 359L787 358M231 359L232 360L231 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M669 359L670 360L669 359M231 360L232 361L231 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M669 360L670 361L669 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M786 360L787 361L786 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M230 361L231 362L230 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M786 361L787 362L786 361M668 362L669 363L668 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M786.333 362.667L786.667 363.333L786.333 362.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M229 363L230 364L229 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M668 363L669 364L668 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M689.333 363.667L689.667 364.333L689.333 363.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M228 364L229 365L228 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M228 365L229 366L228 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M667 365L668 366L667 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M785 365L786 366L785 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M227 366L228 367L227 366M667 366L668 367L667 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M785 366L786 367L785 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M666 367L667 368L666 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M688 367L689 368L688 367M785 367L786 368L785 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M226 368L227 369L226 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M666 368L667 369L666 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M688 368L689 369L688 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M225 369L226 370L225 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M784 369L785 370L784 369M225 370L226 371L225 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M665 370L666 371L665 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M687 370L688 371L687 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M784 370L785 371L784 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M224 371L225 372L224 371M665 371L666 372L665 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M687 371L688 372L687 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M784.333 371.667L784.667 372.333L784.333 371.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M664 372L665 373L664 372M687 372L688 373L687 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M223 373L224 374L223 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M664 373L665 374L664 373M222 374L223 375L222 374M686 374L687 375L686 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M783 374L784 375L783 374M222 375L223 376L222 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M663 375L664 376L663 375M686 375L687 376L686 375M783 375L784 376L783 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M221 376L222 377L221 376M663 376L664 377L663 376M783 376L784 377L783 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M662 377L663 378L662 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M685 377L686 378L685 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M220 378L221 379L220 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M662 378L663 379L662 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M685 378L686 379L685 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M782 378L783 379L782 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M219 379L220 380L219 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M661 379L662 380L661 379M685 379L686 380L685 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M782 379L783 380L782 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M219 380L220 381L219 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M661 380L662 381L661 380M782.333 380.667L782.667 381.333L782.333 380.667M218 381L219 382L218 381M684 381L685 382L684 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M660 382L661 383L660 382M684 382L685 383L684 382M217 383L218 384L217 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M781 383L782 384L781 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M216 384L217 385L216 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M659 384L660 385L659 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M683 384L684 385L683 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M781 384L782 385L781 384M683 385L684 386L683 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M781 385L782 386L781 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M215 386L216 387L215 386M658 386L659 387L658 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M683 386L684 387L683 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M214 387L215 388L214 387M658 387L659 388L658 387M682.333 387.667L682.667 388.333L682.333 387.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M780 387L781 388L780 387M657 388L658 389L657 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M780 388L781 389L780 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M213 389L214 390L213 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M657 389L658 390L657 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M682 389L683 390L682 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M780 389L781 390L780 389M212 390L213 391L212 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M656 390L657 391L656 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M211 391L212 392L211 391M656 391L657 392L656 391M681 391L682 392L681 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M779 391L780 392L779 391M211 392L212 393L211 392M655 392L656 393L655 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M681 392L682 393L681 392M779 392L780 393L779 392M210 393L211 394L210 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M655 393L656 394L655 393M779.333 393.667L779.667 394.333L779.333 393.667M209 394L210 395L209 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M654 394L655 395L654 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M680 394L681 395L680 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M209 395L210 396L209 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M654 395L655 396L654 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M680 395L681 396L680 395M208 396L209 397L208 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M653 396L654 397L653 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M778 396L779 397L778 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M207 397L208 398L207 397M653 397L654 398L653 397M679 397L680 398L679 397M778.333 397.667L778.667 398.333L778.333 397.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M652 398L653 399L652 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M679 398L680 399L679 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M206 399L207 400L206 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M652 399L653 400L652 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M679 399L680 400L679 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M205 400L206 401L205 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M651 400L652 401L651 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M678 400L679 401L678 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M777 400L778 401L777 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M651 401L652 402L651 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M678 401L679 402L678 401M777 401L778 402L777 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M204 402L205 403L204 402M650 402L651 403L650 402M678 402L679 403L678 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M777 402L778 403L777 402M203 403L204 404L203 403M650 403L651 404L650 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M649 404L650 405L649 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M677 404L678 405L677 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M776 404L777 405L776 404M202 405L203 406L202 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M649 405L650 406L649 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M677 405L678 406L677 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M776 405L777 406L776 405M201 406L202 407L201 406M648 406L649 407L648 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M776 406L777 407L776 406M200 407L201 408L200 407M676 407L677 408L676 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M200 408L201 409L200 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M647 408L648 409L647 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M676 408L677 409L676 408M775 408L776 409L775 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M199 409L200 410L199 409M775 409L776 410L775 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M198 410L199 411L198 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M646 410L647 411L646 410M675 410L676 411L675 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M775 410L776 411L775 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M198 411L199 412L198 411M675 411L676 412L675 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M197 412L198 413L197 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M645 412L646 413L645 412M674 412L675 413L674 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M774 412L775 413L774 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M196 413L197 414L196 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M644 413L645 414L644 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M674 413L675 414L674 413M774 413L775 414L774 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M196 414L197 415L196 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M644 414L645 415L644 414M774 414L775 415L774 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M195 415L196 416L195 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M643 415L644 416L643 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M673 415L674 416L673 415M194 416L195 417L194 416M643 416L644 417L643 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M673 416L674 417L673 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M773 416L774 417L773 416M194 417L195 418L194 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M642 417L643 418L642 417M773 417L774 418L773 417M193 418L194 419L193 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M672 418L673 419L672 418M773 418L774 419L773 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M641 419L642 420L641 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M672 419L673 420L672 419M192 420L193 421L192 420M772 420L773 421L772 420z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M191 421L192 422L191 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M640 421L641 422L640 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 421L672 422L671 421M772 421L773 422L772 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M190 422L191 423L190 422M639 422L640 423L639 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M772 422L773 423L772 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M189 423L190 424L189 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M639 423L640 424L639 423M670 423L671 424L670 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M188 424L189 425L188 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M638 424L639 425L638 424M670 424L671 425L670 424M771 424L772 425L771 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M638 425L639 426L638 425M669 425L670 426L669 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M771 425L772 426L771 425M187 426L188 427L187 426M637 426L638 427L637 426M669 426L670 427L669 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M771 426L772 427L771 426M668 427L669 428L668 427M186 428L187 429L186 428M636 428L637 429L636 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M668 428L669 429L668 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M770 428L771 429L770 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M186 429L186 434L187 434L186 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M635 429L636 430L635 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M667 429L668 430L667 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M770 429L771 430L770 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M635 430L636 431L635 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M667 430L668 431L667 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M770 430L771 431L770 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M634 431L635 432L634 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M666 431L667 432L666 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M666 432L667 433L666 432M769 432L770 433L769 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M633 433L634 434L633 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 433L666 434L665 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M769 433L770 434L769 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M186 434L187 435L186 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M665 434L666 435L665 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M769 434L770 435L769 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M187 435L188 436L187 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M632 435L633 436L632 435M664 435L665 436L664 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M631 436L632 437L631 436M768 436L769 437L768 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M188 437L189 438L188 437M631 437L632 438L631 437M663 437L664 438L663 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M768 437L769 438L768 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M189 438L190 439L189 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M630 438L631 439L630 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M768 438L769 439L768 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M662 439L663 440L662 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M190 440L191 441L190 440M629 440L630 441L629 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M767 440L768 441L767 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M191 441L192 442L191 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M628 441L629 442L628 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M661 441L662 442L661 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M767.333 441.667L767.667 442.333L767.333 441.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M192 442L193 443L192 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M628 442L629 443L628 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M193 443L194 444L193 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M627 443L628 444L627 443M660 443L661 444L660 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M194 444L195 445L194 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M766 444L767 445L766 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M195 445L196 446L195 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M626 445L627 446L626 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M659 445L660 446L659 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M766.333 445.667L766.667 446.333L766.333 445.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M196 446L197 447L196 446M625 446L626 447L625 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M197 447L198 448L197 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M658 447L659 448L658 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M198 448L199 449L198 448M624 448L625 449L624 448M765 448L766 449L765 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M199 449L200 450L199 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M200 449L201 450L200 449M623 449L624 450L623 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M657 449L658 450L657 449M765 449L766 450L765 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M201 450L202 451L201 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M623 450L624 451L623 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M657 450L658 451L657 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M202 451L203 452L202 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 451L623 452L622 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M656 451L657 452L656 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M764 451L765 452L764 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M204 452L205 453L204 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M656 452L657 453L656 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M764 452L765 453L764 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M205 453L206 454L205 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M206 453L207 454L206 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M621 453L622 454L621 453M655 453L656 454L655 453M764 453L765 454L764 453M207 454L208 455L207 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M208 454L209 455L208 454M620 454L621 455L620 454M655 454L656 455L655 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M209 455L210 456L209 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M210 455L211 456L210 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M212.667 455.333L213.333 455.667L212.667 455.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M214 455L214 456L219 456L214 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M219 455L220 456L219 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M620 455L621 456L620 455M654 455L655 456L654 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M763 455L764 456L763 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M221 456L222 457L221 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M222 456L223 457L222 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M223 456L224 457L223 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M619 456L620 457L619 456M654 456L655 457L654 456M763 456L764 457L763 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M224 457L225 458L224 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M618 457L619 458L618 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M763 457L764 458L763 457M225 458L226 459L225 458M618 458L619 459L618 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M653 458L654 459L653 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M226 459L227 460L226 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M617 459L618 460L617 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M762 459L763 460L762 459M227 460L228 461L227 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M652 460L653 461L652 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M762 460L763 461L762 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M227 461L228 462L227 461M616 461L617 462L616 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M652 461L653 462L652 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M762 461L763 462L762 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M615 462L616 463L615 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M651 462L652 463L651 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M651 463L652 464L651 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M761 463L762 464L761 463M228 464L229 465L228 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M614 464L615 465L614 464M761.333 464.667L761.667 465.333L761.333 464.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M613 465L614 466L613 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M650 465L651 466L650 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M613 466L614 467L613 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M612 467L613 468L612 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M649 467L650 468L649 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M760 467L761 468L760 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M227 468L228 469L227 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M611 468L612 469L611 468M649 468L650 469L649 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M760 468L761 469L760 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M227 469L228 470L227 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M611 469L612 470L611 469M648 469L649 470L648 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M610 470L611 471L610 470M648 470L649 471L648 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M759 470L760 471L759 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M226 471L227 472L226 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M609 471L610 472L609 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M759 471L760 472L759 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M226 472L227 473L226 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M609 472L610 473L609 472M647 472L648 473L647 472M759 472L760 473L759 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M608 473L609 474L608 473M647 473L648 474L647 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M608 474L609 475L608 474M646 474L647 475L646 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M758 474L759 475L758 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M225 475L225 479L226 479L225 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M607 475L608 476L607 475M646 475L647 476L646 475M758 475L759 476L758 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M758 476L759 477L758 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M606 477L607 478L606 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M645 477L646 478L645 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M645 478L646 479L645 478M757 478L758 479L757 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M225.333 479.667L225.667 480.333L225.333 479.667M605 479L606 480L605 479M757 479L758 480L757 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M644 480L645 481L644 480M757 480L758 481L757 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M225.333 481.667L225.667 482.333L225.333 481.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M604 481L605 482L604 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M644 481L645 482L644 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M643 482L644 483L643 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M756 482L757 483L756 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M603 483L604 484L603 483M643 483L644 484L643 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M756.333 483.667L756.667 484.333L756.333 483.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M224 484L225 485L224 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M223 485L224 486L223 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M602 485L603 486L602 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M642 485L643 486L642 485M222 486L223 487L222 486M602 486L603 487L602 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M642 486L643 487L642 486M755 486L756 487L755 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M221 487L222 488L221 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M601 487L602 488L601 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M755.333 487.667L755.667 488.333L755.333 487.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M221 488L222 489L221 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M601 488L602 489L601 488M641 488L642 489L641 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M220 489L221 490L220 489M641 489L642 490L641 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M219 490L220 491L219 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M600 490L601 491L600 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M754 490L755 491L754 490M219 491L220 492L219 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M600 491L601 492L600 491M640 491L641 492L640 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M754.333 491.667L754.667 492.333L754.333 491.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M218 492L219 493L218 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M599 492L600 493L599 492M640 492L641 493L640 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M218 493L219 494L218 493M599 493L600 494L599 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M754 493L755 494L754 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M218 494L219 495L218 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M639 494L640 495L639 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M598 495L599 496L598 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M639 495L640 496L639 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M598 496L599 497L598 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M753.333 496.667L753.667 497.333L753.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M218 497L219 498L218 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M638 497L639 498L638 497M218 498L219 499L218 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M597 498L598 499L597 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M638 498L639 499L638 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M753 498L754 499L753 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M219 499L220 500L219 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M597 499L598 500L597 499M637 500L638 501L637 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M221 501L222 502L221 501M596 501L597 502L596 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M637 501L638 502L637 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M752 501L753 502L752 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M222 502L223 503L222 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M223 502L224 503L223 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M596 502L597 503L596 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M637 502L638 503L637 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M752 502L753 503L752 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M224 503L225 504L224 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M225 503L226 504L225 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M596 503L597 504L596 503M636 503L637 504L636 503M752.333 503.667L752.667 504.333L752.333 503.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M227 504L228 505L227 504M636 504L637 505L636 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M229 505L230 506L229 505M595 505L596 506L595 505M636 505L637 506L636 505M230 506L231 507L230 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M595 506L596 507L595 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M231 507L232 508L231 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M595 507L596 508L595 507M635 507L636 508L635 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M751 507L752 508L751 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M231 508L232 509L231 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M635 508L636 509L635 508M751.333 508.667L751.667 509.333L751.333 508.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M232 509L233 510L232 509M594 509L595 510L594 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M232 510L232 514L233 514L232 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M594 510L595 511L594 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M634 510L635 511L634 510M751.333 510.667L751.667 511.333L751.333 510.667M594.333 511.667L594.667 512.333L594.333 511.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M634 511L635 512L634 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 513L634 514L633 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M232 514L233 515L232 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M593 514L594 515L593 514M633 514L634 515L633 514M750 514L751 515L750 514M232 515L233 516L232 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M593 515L594 516L593 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M632 515L633 516L632 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M750.333 515.667L750.667 516.333L750.333 515.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M593.333 516.667L593.667 517.333L593.333 516.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M632 516L633 517L632 516M231 517L232 518L231 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M631.333 517.667L631.667 518.333L631.333 517.667M750 517L750 520L751 520L750 517M230 518L231 519L230 518M229 519L230 520L229 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M631 519L632 520L631 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M630 520L631 521L630 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M228 521L229 522L228 521M592 521L593 522L592 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M630 521L631 522L630 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M227 522L228 523L227 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M592.333 522.667L592.667 523.333L592.333 522.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M630 522L631 523L630 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M629 523L630 524L629 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M749 523L750 524L749 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M226 524L227 525L226 524M592 524L592 527L593 527L592 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M629 524L630 525L629 524M749 524L749 527L750 527L749 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M226 525L227 526L226 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M628 525L629 526L628 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M628 526L629 527L628 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M627.333 527.667L627.667 528.333L627.333 527.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M628 527L629 528L628 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M749 527L749 531L750 531L749 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M627 529L628 530L627 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M226 530L227 531L226 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M626 530L627 531L626 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M591 531L591 544L592 544L591 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M626 531L627 532L626 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M227 532L228 533L227 532M625 532L626 533L625 532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M228 533L229 534L228 533M625 533L626 534L625 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M229 534L230 535L229 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M625 534L626 535L625 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M231 535L232 536L231 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M624 535L625 536L624 535M233 536L234 537L233 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M234 536L235 537L234 536M624 536L625 537L624 536M748 536L748 540L749 540L748 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M236 537L237 538L236 537M623 537L624 538L623 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M238 538L239 539L238 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M623 538L624 539L623 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M239 539L240 540L239 539M623 539L624 540L623 539M240 540L241 541L240 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M622 540L623 541L622 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M748 540L748 556L749 556L748 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M241 541L242 542L241 541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 541L623 542L622 541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M241 542L242 543L241 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M622 542L623 543L622 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M242 543L243 544L242 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M621 543L622 544L621 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M243 544L244 545L243 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M621 544L622 545L621 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M243 545L244 546L243 545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M621 545L622 546L621 545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M244 546L245 547L244 546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M620 546L621 547L620 546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M620 547L621 548L620 547M245 548L246 549L245 548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M592 548L592 552L593 552L592 548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M620 548L621 549L620 548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M245 549L246 550L245 549M619 549L620 550L619 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M246 550L247 551L246 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M619 550L620 551L619 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M246 551L247 552L246 551M618.333 551.667L618.667 552.333L618.333 551.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M619 551L620 552L619 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M592.333 552.667L592.667 553.333L592.333 552.667M247 553L248 554L247 553M618 553L619 554L618 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M247 554L248 555L247 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M592 554L593 555L592 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M617.333 554.667L617.667 555.333L617.333 554.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M618 554L619 555L618 554M625 555L626 556L625 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M247 556L248 557L247 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M617 556L618 557L617 556M625 556L625 560L626 560L625 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M748 556L748 560L749 560L748 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M247 557L248 558L247 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M593.333 557.667L593.667 558.333L593.333 557.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M617 557L618 558L617 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M616 558L617 559L616 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M624 558L625 559L624 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M246 559L247 560L246 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M593.333 559.667L593.667 560.333L593.333 559.667M616 559L617 560L616 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M624.333 559.667L624.667 560.333L624.333 559.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M246 560L247 561L246 560M616 560L617 561L616 560M625.333 560.667L625.667 561.333L625.333 560.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M245 561L246 562L245 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M593 561L594 562L593 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M615.333 561.667L615.667 562.333L615.333 561.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M623 561L624 562L623 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M245 562L246 563L245 562M623 562L624 563L623 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M594.333 563.667L594.667 564.333L594.333 563.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M615.333 563.667L615.667 564.333L615.333 563.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M623 563L624 564L623 563M244 564L245 565L244 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M622 564L623 565L622 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M244 565L245 566L244 565M594 565L595 566L594 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M614 565L615 566L614 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 565L623 566L622 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M624 565L624 569L625 569L624 565M749 565L749 569L750 569L749 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M244 566L245 567L244 566M594 566L595 567L594 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M614 566L615 567L614 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M622.333 566.667L622.667 567.333L622.333 566.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M614 567L615 568L614 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M243 568L244 569L243 568M595 568L596 569L595 568M613.333 568.667L613.667 569.333L613.333 568.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M621 568L622 569L621 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M243 569L244 570L243 569M595 569L596 570L595 569M621 569L622 570L621 569M624 569L624 573L625 573L624 569M749.333 569.667L749.667 570.333L749.333 569.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M243 570L244 571L243 570M595 570L596 571L595 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M613 570L614 571L613 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M621 570L622 571L621 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M613 571L614 572L613 571M620.333 571.667L620.667 572.333L620.333 571.667M749.333 571.667L749.667 572.333L749.333 571.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M596 572L597 573L596 572M612.333 572.667L612.667 573.333L612.333 572.667M242 573L242 576L243 576L242 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M596 573L597 574L596 573M620 573L621 574L620 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M624 573L624 577L625 577L624 573M596 574L597 575L596 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M612 574L613 575L612 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M620 574L621 575L620 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M612 575L613 576L612 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M750 575L750 578L751 578L750 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M242 576L242 581L243 581L242 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M597 576L598 577L597 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M619 576L620 577L619 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M597 577L598 578L597 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M611 577L612 578L611 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M619 577L620 578L619 577M611.333 578.667L611.667 579.333L611.333 578.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M619.333 578.667L619.667 579.333L619.333 578.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M750 578L751 579L750 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M598 579L599 580L598 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M750.333 579.667L750.667 580.333L750.333 579.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M598 580L599 581L598 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M611 580L612 581L611 580M618 580L619 581L618 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M242 581L242 584L243 584L242 581M610.333 581.667L610.667 582.333L610.333 581.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M618 581L619 582L618 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M702 581L702 585L703 585L702 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M599 582L600 583L599 582M618.333 582.667L618.667 583.333L618.333 582.667M623 582L623 587L624 587L623 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M599 583L600 584L599 583M610 583L611 584L610 583M703 583L702 595L703 595L703 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M751 583L752 584L751 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M610 584L611 585L610 584M617.333 584.667L617.667 585.333L617.333 584.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M751.333 584.667L751.667 585.333L751.333 584.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M243 585L244 586L243 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M600 585L601 586L600 585M703 585L704 586L703 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M243 586L244 587L243 586M600 586L601 587L600 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M609.333 586.667L609.667 587.333L609.333 586.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M617 586L618 587L617 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M751 586L752 587L751 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M243 587L244 588L243 587M617.333 587.667L617.667 588.333L617.333 587.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M623.333 587.667L623.667 588.333L623.333 587.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M601 588L602 589L601 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M609 588L610 589L609 588M704 588L705 589L704 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M752.333 588.667L752.667 589.333L752.333 588.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M244 589L245 590L244 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M601 589L602 590L601 589M609 589L610 590L609 589M616.333 589.667L616.667 590.333L616.333 589.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M623 589L623 595L624 595L623 589M704.333 589.667L704.667 590.333L704.333 589.667M602 590L603 591L602 590M608.333 590.667L608.667 591.333L608.333 590.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M752 590L753 591L752 590M245 591L246 592L245 591M602 591L603 592L602 591M616 591L617 592L616 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M752 591L753 592L752 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M608 592L609 593L608 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M616.333 592.667L616.667 593.333L616.333 592.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M705 592L706 593L705 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M246 593L247 594L246 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M603 593L604 594L603 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M608.333 593.667L608.667 594.333L608.333 593.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M705 593L706 594L705 593M753.333 593.667L753.667 594.333L753.333 593.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M247 594L248 595L247 594M603 594L604 595L603 594M615 594L616 595L615 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M247 595L248 596L247 595M604 595L605 596L604 595M607 595L606 600L607 600L607 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M615.333 595.667L615.667 596.333L615.333 595.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M702 595L702 599L703 599L702 595M706 595L707 596L706 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M753 595L754 596L753 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M248 596L249 597L248 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M604 596L605 597L604 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M706 596L707 597L706 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M753 596L754 597L753 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M249 597L250 598L249 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M605 597L606 598L605 597M615 597L615 600L616 600L615 597M706 597L707 598L706 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M250 598L251 599L250 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M605 598L606 599L605 598M624 598L625 599L624 598M707 598L708 599L707 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M754 598L755 599L754 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M251 599L252 600L251 599M607.333 599.667L607.667 600.333L607.333 599.667M624.333 599.667L624.667 600.333L624.333 599.667M707 599L708 600L707 599M754 599L755 600L754 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M252 600L253 601L252 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M606 600L607 601L606 600M754 600L755 601L754 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M253 601L254 602L253 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M342.667 601.333L343.333 601.667L342.667 601.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M344 601L344 602L352 602L344 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M352 601L353 602L352 601M607 601L608 602L607 601M614 601L614 606L615 606L614 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M624.333 601.667L624.667 602.333L624.333 601.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M708 601L709 602L708 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M255 602L256 603L255 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M335 602L336 603L335 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M336.667 602.333L337.333 602.667L336.667 602.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M338.667 602.333L339.333 602.667L338.667 602.333M355.667 602.333L356.333 602.667L355.667 602.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M357 602L358 603L357 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M358 602L359 603L358 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M708 602L709 603L708 602M755 602L756 603L755 602M256 603L257 604L256 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M329 603L330 604L329 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M330.667 603.333L331.333 603.667L330.667 603.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M332.667 603.333L333.333 603.667L332.667 603.333M360 603L361 604L360 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M361 603L362 604L361 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M703 603L703 607L704 607L703 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M755 603L756 604L755 603M258 604L259 605L258 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M323 604L324 605L323 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M324 604L325 605L324 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M325 604L325 605L328 605L325 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M363 604L364 605L363 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M364 604L365 605L364 604M625 604L626 605L625 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M709 604L710 605L709 604M260 605L261 606L260 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M316 605L317 606L316 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M317.667 605.333L318.333 605.667L317.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M319.667 605.333L320.333 605.667L319.667 605.333M365 605L366 606L365 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M366 605L367 606L366 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M625 605L626 606L625 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M756.333 605.667L756.667 606.333L756.333 605.667M262 606L263 607L262 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M263 606L264 607L263 606M309 606L310 607L309 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M310.667 606.333L311.333 606.667L310.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M312.667 606.333L313.333 606.667L312.667 606.333M367 606L368 607L367 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M614 606L614 612L615 612L614 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M625.333 606.667L625.667 607.333L625.333 606.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M710 606L711 607L710 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M264 607L265 608L264 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M265 607L266 608L265 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M266 607L267 608L266 607M301 607L302 608L301 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M302.667 607.333L303.333 607.667L302.667 607.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M304 607L304 608L307 608L304 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M369 607L370 608L369 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M703.333 607.667L703.667 608.333L703.333 607.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M710 607L711 608L710 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M756 607L757 608L756 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M268 608L269 609L268 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M269 608L270 609L269 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M291.667 608.333L292.333 608.667L291.667 608.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M293 608L293 609L296 609L293 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M296 608L296 609L299 609L296 608M370 608L371 609L370 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M711 608L712 609L711 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M272 609L272 610L275 610L272 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M275 609L275 610L283 610L275 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M283 609L283 610L288 610L283 609M371 609L372 610L371 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M626 609L627 610L626 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M703.333 609.667L703.667 610.333L703.333 609.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M711 609L712 610L711 609M757 609L758 610L757 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M373 610L374 611L373 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M626.333 610.667L626.667 611.333L626.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M712 610L713 611L712 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M757 610L758 611L757 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M374 611L375 612L374 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M712 611L713 612L712 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M375 612L376 613L375 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M614.333 612.667L614.667 613.333L614.333 612.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M713 612L714 613L713 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M758 612L759 613L758 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M627 613L628 614L627 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M704 613L704 616L705 616L704 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M758 613L759 614L758 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M376 614L377 615L376 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M614 614L615 615L614 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M627 614L628 615L627 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M714 614L715 615L714 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M377 615L378 616L377 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M614 615L615 616L614 615M715 615L716 616L715 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M759 615L760 616L759 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M378 616L379 617L378 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M615 616L616 617L615 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M628 616L629 617L628 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M704 616L705 617L704 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M715 616L716 617L715 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M759 616L760 617L759 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M379 617L380 618L379 617M615 617L616 618L615 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M628 617L629 618L628 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M704 617L705 618L704 617M716 617L717 618L716 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M379 618L380 619L379 618M616 618L617 619L616 618M760 618L761 619L760 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M380 619L381 620L380 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M616 619L617 620L616 619M629 619L630 620L629 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M717 619L718 620L717 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M760 619L761 620L760 619M381 620L382 621L381 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M617 620L618 621L617 620M629 620L630 621L629 620M705.333 620.667L705.667 621.333L705.333 620.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M718 620L719 621L718 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M761 620L762 621L761 620M381 621L382 622L381 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M617 621L618 622L617 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M761 621L762 622L761 621M382 622L383 623L382 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M618 622L619 623L618 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M630 622L631 623L630 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M705 622L706 623L705 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M719 622L720 623L719 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M618 623L619 624L618 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M630 623L631 624L630 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M705 623L706 624L705 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M720 623L721 624L720 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M762 623L763 624L762 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M383 624L384 625L383 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M619 624L620 625L619 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M721 624L722 625L721 624M762 624L763 625L762 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M631 625L632 626L631 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M706.333 625.667L706.667 626.333L706.333 625.667M763 625L764 626L763 625M384 626L385 627L384 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M620 626L621 627L620 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M722 626L723 627L722 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M763 626L764 627L763 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M385 627L386 628L385 627M632 627L633 628L632 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M706 627L707 628L706 627M723 627L724 628L723 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M385 628L386 629L385 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M621 628L622 629L621 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M632 628L633 629L632 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M706 628L707 629L706 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M724 628L725 629L724 628M764 628L765 629L764 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M386 629L387 630L386 629M633 629L634 630L633 629M725 629L726 630L725 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M386 630L387 631L386 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 630L623 631L622 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 630L634 631L633 630M707.333 630.667L707.667 631.333L707.333 630.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M726 630L727 631L726 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M765 630L766 631L765 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M387 631L388 632L387 631M727 631L728 632L727 631M765 631L766 632L765 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M387 632L388 633L387 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M623 632L624 633L623 632M634 632L635 633L634 632M707 632L708 633L707 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M728 632L729 633L728 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M766 632L767 633L766 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M388 633L389 634L388 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M624 633L625 634L624 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M729 633L730 634L729 633M766 633L767 634L766 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M388 634L389 635L388 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M624 634L625 635L624 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M635 634L636 635L635 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M730 634L731 635L730 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M767 634L768 635L767 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M389 635L390 636L389 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M625 635L626 636L625 635M708 635L709 636L708 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M731 635L732 636L731 635M767 635L768 636L767 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M389 636L390 637L389 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M625 636L626 637L625 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M636 636L637 637L636 636M708 636L709 637L708 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M732 636L733 637L732 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M768 636L769 637L768 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M390 637L391 638L390 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M626 637L627 638L626 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M733 637L734 638L733 637M768 637L769 638L768 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M390 638L391 639L390 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M626 638L627 639L626 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M637 638L638 639L637 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M709.333 638.667L709.667 639.333L709.333 638.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M734 638L735 639L734 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M769 638L770 639L769 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M391 639L392 640L391 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M627 639L628 640L627 639M735 639L736 640L735 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M769 639L770 640L769 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M391 640L392 641L391 640M638 640L639 641L638 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M709 640L710 641L709 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M736 640L737 641L736 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M770 640L771 641L770 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M628 641L629 642L628 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M639 641L640 642L639 641M738 641L739 642L738 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M392 642L393 643L392 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M639 642L640 643L639 642M710 642L711 643L710 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M739 642L740 643L739 642M771 642L772 643L771 642M629 643L630 644L629 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M640 643L641 644L640 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M710 643L711 644L710 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M740 643L741 644L740 643M772 643L773 644L772 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M393 644L394 645L393 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M640 644L641 645L640 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M710 644L711 645L710 644M742 644L743 645L742 644M772 644L773 645L772 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M630 645L631 646L630 645M641 645L642 646L641 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M711 645L712 646L711 645M743 645L744 646L743 645M773 645L774 646L773 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M394 646L395 647L394 646M711 646L712 647L711 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M745 646L746 647L745 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M394 647L395 648L394 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M631 647L632 648L631 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M642 647L643 648L642 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M711 647L712 648L711 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M746 647L747 648L746 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M747 647L748 648L747 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M774 647L775 648L774 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M395 648L396 649L395 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M632 648L633 649L632 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M643 648L644 649L643 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M748 648L749 649L748 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M775 648L776 649L775 648M395 649L396 650L395 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M632 649L633 650L632 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M712 649L713 650L712 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M750 649L751 650L750 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M775 649L776 650L775 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 650L634 651L633 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M644 650L645 651L644 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M712 650L713 651L712 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M751 650L752 651L751 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M752 650L753 651L752 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M776 650L777 651L776 650M396 651L397 652L396 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M633 651L634 652L633 651M645 651L646 652L645 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M753 651L754 652L753 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M754 651L755 652L754 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M777 651L778 652L777 651M634 652L635 653L634 652M645 652L646 653L645 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M713 652L714 653L713 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M755 652L756 653L755 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M756 652L757 653L756 652M777 652L778 653L777 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M397 653L398 654L397 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M634 653L635 654L634 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M646 653L647 654L646 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M713 653L714 654L713 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M757 653L758 654L757 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M758 653L759 654L758 653M778 653L779 654L778 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M397 654L398 655L397 654M635 654L636 655L635 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M647 654L648 655L647 654M687 654L688 655L687 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M714 654L715 655L714 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M760 654L761 655L760 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M779 654L780 655L779 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M398 655L399 656L398 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M647 655L648 656L647 655M687 655L687 660L688 660L687 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M714 655L715 656L714 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M762 655L763 656L762 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M763 655L764 656L763 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M398 656L399 657L398 656M636 656L637 657L636 656M648 656L649 657L648 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M687 656L688 657L687 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M714 656L715 657L714 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M765 656L766 657L765 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M766 656L767 657L766 656M780 656L781 657L780 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M649 657L650 658L649 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M689 657L690 658L689 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M715 657L716 658L715 657M767 657L768 658L767 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M768 657L769 658L768 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M769 657L770 658L769 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M781 657L782 658L781 657M399 658L400 659L399 658M637 658L638 659L637 658M715 658L716 659L715 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M770 658L771 659L770 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M771 658L772 659L771 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M772 658L773 659L772 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M782 658L783 659L782 658M650 659L651 660L650 659M690 659L691 660L690 659M774 659L775 660L774 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M775 659L776 660L775 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M400 660L401 661L400 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M638 660L639 661L638 660M651 660L652 661L651 660M687 660L688 661L687 660M691 660L692 661L691 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M716 660L717 661L716 660M777 660L778 661L777 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M778 660L779 661L778 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M779 660L780 661L779 660M783 660L784 661L783 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M400 661L401 662L400 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M652 661L653 662L652 661M687 661L688 662L687 661M692 661L693 662L692 661M716 661L717 662L716 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M781.667 661.333L782.333 661.667L781.667 661.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M783.667 661.333L784.333 661.667L783.667 661.333M639 662L640 663L639 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M692 662L693 663L692 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M401 663L402 664L401 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M640 663L641 664L640 663M653 663L654 664L653 663M693 663L694 664L693 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M717 663L718 664L717 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M640 664L641 665L640 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M654 664L655 665L654 664M688.333 664.667L688.667 665.333L688.333 664.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M694 664L695 665L694 664M402 665L403 666L402 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M641 665L642 666L641 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M655 665L656 666L655 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M695 665L696 666L695 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M718 665L719 666L718 665M402 666L403 667L402 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M641 666L642 667L641 666M656 666L657 667L656 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M688 666L689 667L688 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M718 666L719 667L718 666M403 667L404 668L403 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M642 667L643 668L642 667M696 667L697 668L696 667M719 667L720 668L719 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M403 668L404 669L403 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M642 668L643 669L642 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M657 668L658 669L657 668M697 668L698 669L697 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M719 668L720 669L719 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M643 669L644 670L643 669M658 669L659 670L658 669M689 669L690 670L689 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M698 669L699 670L698 669M404 670L405 671L404 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M643 670L644 671L643 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M659 670L660 671L659 670M689 670L690 671L689 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M699 670L700 671L699 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M720 670L721 671L720 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M404 671L405 672L404 671M644 671L645 672L644 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M660 671L661 672L660 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M700 671L701 672L700 671M661 672L662 673L661 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M690.333 672.667L690.667 673.333L690.333 672.667M700 672L701 673L700 672M721 672L722 673L721 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M405 673L406 674L405 673M645 673L646 674L645 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M662 673L663 674L662 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M701 673L702 674L701 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M721 673L722 674L721 673M690 674L691 675L690 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M702 674L703 675L702 674M722 674L723 675L722 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M406 675L407 676L406 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M646 675L647 676L646 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M663 675L664 676L663 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M703 675L704 676L703 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M722 675L723 676L722 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M406 676L407 677L406 676M664 676L665 677L664 676M691 676L692 677L691 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M704 676L705 677L704 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M723 676L724 677L723 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M647 677L648 678L647 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 677L666 678L665 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M691 677L692 678L691 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M705 677L706 678L705 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M723 677L724 678L723 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M407 678L408 679L407 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M648 678L649 679L648 678M666 678L667 679L666 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M706 678L707 679L706 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M724 678L725 679L724 678M407 679L408 680L407 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M648 679L649 680L648 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M667 679L668 680L667 679M692 679L693 680L692 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M707 679L708 680L707 679M724 679L725 680L724 679M408 680L409 681L408 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M649 680L650 681L649 680M668 680L669 681L668 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M692 680L693 681L692 680M708 680L709 681L708 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M725 680L726 681L725 680M408 681L409 682L408 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M649 681L650 682L649 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M669 681L670 682L669 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M709 681L710 682L709 681M725 681L726 682L725 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M650 682L651 683L650 682M670 682L671 683L670 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M693 682L694 683L693 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M710 682L711 683L710 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M726 682L727 683L726 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M409 683L410 684L409 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M650 683L651 684L650 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 683L672 684L671 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M693 683L694 684L693 683M711 683L712 684L711 683M726 683L727 684L726 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M409 684L410 685L409 684M651 684L652 685L651 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M672 684L673 685L672 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694 684L695 685L694 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M712 684L713 685L712 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M727 684L728 685L727 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M651 685L652 686L651 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M673 685L674 686L673 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M694 685L695 686L694 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M713 685L714 686L713 685M727 685L728 686L727 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M410 686L411 687L410 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M652 686L653 687L652 686M674 686L675 687L674 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M714 686L715 687L714 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M728 686L729 687L728 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M410 687L411 688L410 687M675 687L676 688L675 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M695 687L696 688L695 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M715 687L716 688L715 687M411 688L412 689L411 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M653 688L654 689L653 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M676 688L677 689L676 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M695 688L696 689L695 688M716 688L717 689L716 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M729 688L730 689L729 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M411 689L412 690L411 689M677 689L678 690L677 689M696 689L697 690L696 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M717 689L718 690L717 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M654 690L655 691L654 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M678 690L679 691L678 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M696 690L697 691L696 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M718 690L719 691L718 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M730 690L731 691L730 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M412 691L413 692L412 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M679 691L680 692L679 691M697 691L698 692L697 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M719 691L720 692L719 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M731 691L732 692L731 691M412 692L413 693L412 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M655 692L656 693L655 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M681 692L682 693L681 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M697 692L698 693L697 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M720 692L721 693L720 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M731 692L732 693L731 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M656 693L657 694L656 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M682 693L683 694L682 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M721 693L722 694L721 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M732 693L733 694L732 693M413 694L414 695L413 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M656 694L657 695L656 694M683 694L684 695L683 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M698 694L699 695L698 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M722 694L723 695L722 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M723 694L724 695L723 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M413 695L414 696L413 695M657 695L658 696L657 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M684 695L685 696L684 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M724 695L725 696L724 695M733 695L734 696L733 695M414 696L415 697L414 696M657 696L658 697L657 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M685 696L686 697L685 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M699 696L700 697L699 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M725 696L726 697L725 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M734 696L735 697L734 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M414 697L415 698L414 697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M658 697L659 698L658 697M686 697L687 698L686 697M726 697L727 698L726 697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M658 698L659 699L658 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M687 698L688 699L687 698M700 698L701 699L700 698M727 698L728 699L727 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M735 698L736 699L735 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M415 699L416 700L415 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M659 699L660 700L659 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M689 699L690 700L689 699M729 699L730 700L729 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M736 699L737 700L736 699M415 700L416 701L415 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M659 700L660 701L659 700M690 700L691 701L690 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M701 700L702 701L701 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M730 700L731 701L730 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M660 701L661 702L660 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M691 701L692 702L691 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M731 701L732 702L731 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M737 701L738 702L737 701M416 702L417 703L416 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M692 702L693 703L692 702M702 702L703 703L702 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M733 702L734 703L733 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M738 702L739 703L738 702M416 703L417 704L416 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M661 703L662 704L661 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M693 703L694 704L693 703M734 703L735 704L734 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M695 704L696 705L695 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M703 704L704 705L703 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M736 704L737 705L736 704M739 704L740 705L739 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M417 705L418 706L417 705M662 705L663 706L662 705M696 705L697 706L696 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M737 705L738 706L737 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M740 705L741 706L740 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M417 706L418 707L417 706M697 706L698 707L697 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M704 706L705 707L704 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M739 706L740 707L739 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M740 707L740 708L744 709L742 706L740 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M663 707L664 708L663 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M698 707L699 708L698 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M699 707L700 708L699 707M741 707L742 708L741 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M418 708L419 709L418 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M664 708L665 709L664 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M700 708L701 709L700 708M705 708L706 709L705 708M742 708L743 709L742 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M418 709L419 710L418 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M664 709L665 710L664 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M701 709L702 710L701 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M419 710L420 711L419 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 710L666 711L665 710M702 710L703 711L702 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M703 710L704 711L703 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M706 710L707 711L706 710M419 711L420 712L419 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M665 711L666 712L665 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M704 711L705 712L704 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M707 711L708 712L707 711M419 712L420 713L419 712M666 712L667 713L666 712M705 712L706 713L705 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M707.333 712.667L707.667 713.333L707.333 712.667M420 713L421 714L420 713M666 713L667 714L666 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M706 713L707 714L706 713M708.333 713.667L708.667 714.333L708.333 713.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M420 714L421 715L420 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M667 714L668 715L667 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M421 716L422 717L421 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M668 716L669 717L668 716M421 717L422 718L421 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M669 718L670 719L669 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M422 719L423 720L422 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M422 720L423 721L422 720M670 720L671 721L670 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M422 721L423 722L422 721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M423 722L424 723L423 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 722L672 723L671 722M423 723L424 724L423 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M672 723L673 724L672 723M423 724L424 725L423 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M672 724L673 725L672 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M673 725L674 726L673 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M424 726L425 727L424 726M673 726L674 727L673 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M424 727L425 728L424 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M674 727L675 728L674 727M424.333 728.667L424.667 729.333L424.333 728.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M674 728L675 729L674 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M675 729L676 730L675 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M676 731L677 732L676 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M425 732L426 733L425 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M425 733L425 736L426 736L425 733M677 733L678 734L677 733M678 735L679 736L678 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M425 736L425 740L426 740L425 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M679 737L680 738L679 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M680 738L681 739L680 738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M680 739L681 740L680 739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M425.333 740.667L425.667 741.333L425.333 740.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M681 740L682 741L681 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M681 741L682 742L681 741M425 742L426 743L425 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M682 742L683 743L682 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M682 743L683 744L682 743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M683 744L684 745L683 744M424 745L425 746L424 745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M424 746L425 747L424 746M684 746L685 747L684 746M423 748L424 749L423 748M685 748L686 749L685 748M422 750L423 751L422 750M686 750L687 751L686 750z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M421 751L422 752L421 751M687 751L688 752L687 751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M687 752L688 753L687 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M420 753L421 754L420 753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M688 753L689 754L688 753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M419 754L420 755L419 754M688 754L689 755L688 754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M417 755L418 756L417 755M689 755L690 756L689 755M415 756L416 757L415 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M416 756L417 757L416 756M689 756L690 757L689 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M391 757L391 758L397 758L391 757M413 757L414 758L413 757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M414 757L415 758L414 757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M690 757L691 758L690 757M387 758L388 759L387 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M388 758L389 759L388 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M389 758L390 759L389 758M400 758L401 759L400 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M401 758L402 759L401 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M402 758L403 759L402 758M408.667 758.333L409.333 758.667L408.667 758.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M410 758L411 759L410 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M411 758L412 759L411 758M690 758L691 759L690 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M385 759L386 760L385 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M386 759L387 760L386 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M691 759L692 760L691 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M384 760L385 761L384 760M383 761L384 762L383 761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M692 761L693 762L692 761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M382 762L383 763L382 762M381 763L382 764L381 763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M693 763L694 764L693 763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M380 764L381 765L380 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M380 765L381 766L380 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M694 765L695 766L694 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M379 766L380 767L379 766M695 766L696 767L695 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M379 767L380 768L379 767M695 767L696 768L695 767M693 768L694 769L693 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M694 768L695 769L694 768M378.333 769.667L378.667 770.333L378.333 769.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M690 769L691 770L690 769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M691 769L692 770L691 769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M687 770L688 771L687 770z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M688 770L689 771L688 770z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M378 771L379 772L378 771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M683 771L684 772L683 771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M684 771L685 772L684 771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M685 771L686 772L685 771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M378.333 772.667L378.667 773.333L378.333 772.667M680 772L681 773L680 772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M681 772L682 773L681 772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M677 773L678 774L677 773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M678 773L679 774L678 773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M674 774L675 775L674 774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M675 774L676 775L675 774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M378 775L379 776L378 775M670 775L671 776L670 775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M671 775L672 776L671 775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M672 775L673 776L672 775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M378 776L379 777L378 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M667 776L668 777L667 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M668 776L669 777L668 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M669 776L670 777L669 776M378.333 777.667L378.667 778.333L378.333 777.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M664 777L665 778L664 777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M665 777L666 778L665 777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M661 778L662 779L661 778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M662 778L663 779L662 778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M657 779L658 780L657 779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M658 779L659 780L658 779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M659 779L660 780L659 779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M654 780L655 781L654 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M655 780L656 781L655 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M656 780L657 781L656 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M651 781L652 782L651 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M652 781L653 782L652 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M379 782L380 783L379 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M648 782L649 783L648 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M649 782L650 783L649 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M645 783L646 784L645 783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M646 783L647 784L646 783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M641 784L642 785L641 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M642 784L643 785L642 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M643 784L644 785L643 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M638 785L639 786L638 785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M639 785L640 786L639 785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M635 786L636 787L635 786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M636 786L637 787L636 786M378.333 787.667L378.667 788.333L378.333 787.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M632 787L633 788L632 787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M633 787L634 788L633 787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M628 788L629 789L628 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M629 788L630 789L629 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M630 788L631 789L630 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M378 789L379 790L378 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M625 789L626 790L625 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M626 789L627 790L626 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M378 790L379 791L378 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 790L623 791L622 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M623 790L624 791L623 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M619 791L620 792L619 791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M620 791L621 792L620 791M377 792L378 793L377 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M615 792L616 793L615 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M616 792L617 793L616 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M617 792L618 793L617 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M377 793L378 794L377 793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M612 793L613 794L612 793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M613 793L614 794L613 793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M614 793L615 794L614 793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M377 794L378 795L377 794M609 794L610 795L609 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M610 794L611 795L610 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M606 795L607 796L606 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M607 795L608 796L607 795M376 796L377 797L376 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M602 796L603 797L602 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M603 796L604 797L603 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M604 796L605 797L604 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M376 797L377 798L376 797M599 797L600 798L599 797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M600 797L601 798L600 797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M601 797L602 798L601 797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M596 798L597 799L596 798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M597 798L598 799L597 798M375 799L376 800L375 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M593 799L594 800L593 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M594 799L595 800L594 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M375 800L376 801L375 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M590 800L591 801L590 800z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M591 800L592 801L591 800M374 801L375 802L374 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M586 801L587 802L586 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M587 801L588 802L587 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M588 801L589 802L588 801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M374 802L375 803L374 802M583 802L584 803L583 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M584 802L585 803L584 802M373 803L374 804L373 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M580 803L581 804L580 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M581 803L582 804L581 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M577 804L578 805L577 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M578 804L579 805L578 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M372 805L373 806L372 805M573 805L574 806L573 805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M574 805L575 806L574 805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M575 805L576 806L575 805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M371 806L372 807L371 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M570 806L571 807L570 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M571 806L572 807L571 806M370 807L371 808L370 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M567 807L568 808L567 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M568 807L569 808L568 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M564 808L565 809L564 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M565 808L566 809L565 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M369 809L370 810L369 809M560 809L561 810L560 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M561 809L562 810L561 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M562 809L563 810L562 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M368 810L369 811L368 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M557 810L558 811L557 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M558 810L559 811L558 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M559 810L560 811L559 810M367 811L368 812L367 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M554 811L555 812L554 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M555 811L556 812L555 811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M551 812L552 813L551 812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M552 812L553 813L552 812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M366 813L367 814L366 813M547 813L548 814L547 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M548 813L549 814L548 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M549 813L550 814L549 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M365 814L366 815L365 814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M544 814L545 815L544 814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M545 814L546 815L545 814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M546 814L547 815L546 814M364 815L365 816L364 815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M541 815L542 816L541 815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M542 815L543 816L542 815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M538 816L539 817L538 816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M539 816L540 817L539 816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M363 817L364 818L363 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M535 817L536 818L535 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M536 817L537 818L536 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M362 818L363 819L362 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M531 818L532 819L531 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M532 818L533 819L532 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M533 818L534 819L533 818M361 819L362 820L361 819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M528 819L529 820L528 819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M529 819L530 820L529 819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M525 820L526 821L525 820z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M526 820L527 821L526 820z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M360 821L361 822L360 821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M522 821L523 822L522 821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M523 821L524 822L523 821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M359 822L360 823L359 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M518 822L519 823L518 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M519 822L520 823L519 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M520 822L521 823L520 822M358 823L359 824L358 823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M515 823L516 824L515 823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M516 823L517 824L516 823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M512 824L513 825L512 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M513 824L514 825L513 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M357 825L358 826L357 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M509 825L510 826L509 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M510 825L511 826L510 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M356 826L357 827L356 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M505 826L506 827L505 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M506 826L507 827L506 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M507 826L508 827L507 826M355 827L356 828L355 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M502 827L503 828L502 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M503 827L504 828L503 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M504 827L505 828L504 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M499 828L500 829L499 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M500 828L501 829L500 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M354 829L355 830L354 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M496 829L497 830L496 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M497 829L498 830L497 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M353 830L354 831L353 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M492 830L493 831L492 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M493 830L494 831L493 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M494 830L495 831L494 830M352 831L353 832L352 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M489 831L490 832L489 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M490 831L491 832L490 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M491 831L492 832L491 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M486 832L487 833L486 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M487 832L488 833L487 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M351 833L352 834L351 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M483 833L484 834L483 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M484 833L485 834L484 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M350 834L351 835L350 834M480 834L481 835L480 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M481 834L482 835L481 834M349 835L350 836L349 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M476 835L477 836L476 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M477 835L478 836L477 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M478 835L479 836L478 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M473 836L474 837L473 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M474 836L475 837L474 836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M348 837L349 838L348 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M470 837L471 838L470 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M471 837L472 838L471 837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M347 838L348 839L347 838M467 838L468 839L467 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M468 838L469 839L468 838M346 839L347 840L346 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M463 839L464 840L463 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M464 839L465 840L464 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M465 839L466 840L465 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M460 840L461 841L460 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M461 840L462 841L461 840z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M345 841L346 842L345 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M457 841L458 842L457 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M458 841L459 842L458 841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M344 842L345 843L344 842M454 842L455 843L454 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M455 842L456 843L455 842M343 843L344 844L343 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M450 843L451 844L450 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M451 843L452 844L451 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M452 843L453 844L452 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M447 844L448 845L447 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M448 844L449 845L448 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M449 844L450 845L449 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M342 845L343 846L342 845M444 845L445 846L444 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M445 845L446 846L445 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M341 846L342 847L341 846M441 846L442 847L441 846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M442 846L443 847L442 846M340 847L341 848L340 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M437 847L438 848L437 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M438 847L439 848L438 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M439 847L440 848L439 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M434 848L435 849L434 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M435 848L436 849L435 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M436 848L437 849L436 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M339 849L340 850L339 849M431 849L432 850L431 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M432 849L433 850L432 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M338 850L339 851L338 850M428 850L429 851L428 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M429 850L430 851L429 850M337 851L338 852L337 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M425 851L426 852L425 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M426 851L427 852L426 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M421 852L422 853L421 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M422 852L423 853L422 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M423 852L424 853L423 852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M336 853L337 854L336 853M418 853L419 854L418 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M419 853L420 854L419 853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M335 854L336 855L335 854M415 854L416 855L415 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M416 854L417 855L416 854M334 855L335 856L334 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M412 855L413 856L412 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M413 855L414 856L413 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M408 856L409 857L408 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M409 856L410 857L409 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M410 856L411 857L410 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M333 857L334 858L333 857M405 857L406 858L405 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M406 857L407 858L406 857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M332 858L333 859L332 858M402 858L403 859L402 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M403 858L404 859L403 858M331 859L332 860L331 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M399 859L400 860L399 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M400 859L401 860L400 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M395 860L396 861L395 860z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M396 860L397 861L396 860z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M397 860L398 861L397 860z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M330 861L331 862L330 861M392 861L393 862L392 861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M393 861L394 862L393 861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M394 861L395 862L394 861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M329 862L330 863L329 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M389 862L390 863L389 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M390 862L391 863L390 862M328 863L329 864L328 863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M386 863L387 864L386 863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M387 863L388 864L387 863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M382 864L383 865L382 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M383 864L384 865L383 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M384 864L385 865L384 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M327 865L328 866L327 865M379 865L380 866L379 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M380 865L381 866L380 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M381 865L382 866L381 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M326 866L327 867L326 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M376 866L377 867L376 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M377 866L378 867L377 866M325 867L326 868L325 867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M373 867L374 868L373 867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M374 867L375 868L374 867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M370 868L371 869L370 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M371 868L372 869L371 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M324 869L325 870L324 869M366 869L367 870L366 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M367 869L368 870L367 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M368 869L369 870L368 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M323 870L324 871L323 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M363 870L364 871L363 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M364 870L365 871L364 870M322 871L323 872L322 871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M360 871L361 872L360 871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M361 871L362 872L361 871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M357 872L358 873L357 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M358 872L359 873L358 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M321 873L322 874L321 873M353 873L354 874L353 873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M354 873L355 874L354 873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M355 873L356 874L355 873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M320 874L321 875L320 874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M350 874L351 875L350 874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M351 874L352 875L351 874M319 875L320 876L319 875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M347 875L348 876L347 875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M348 875L349 876L348 875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M344 876L345 877L344 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M345 876L346 877L345 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M318 877L319 878L318 877M340 877L341 878L340 877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M341 877L342 878L341 877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M342 877L343 878L342 877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M317 878L318 879L317 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M337 878L338 879L337 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M338 878L339 879L338 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M339 878L340 879L339 878M316 879L317 880L316 879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M334 879L335 880L334 879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M335 879L336 880L335 879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M331 880L332 881L331 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M332 880L333 881L332 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M315 881L316 882L315 881M327 881L328 882L327 881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M328 881L329 882L328 881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M329 881L330 882L329 881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M314 882L315 883L314 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M324 882L325 883L324 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M325 882L326 883L325 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M326 882L327 883L326 882M313 883L314 884L313 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M321 883L322 884L321 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M322 883L323 884L322 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M318 884L319 885L318 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M319 884L320 885L319 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M312 885L313 886L312 885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M315 885L316 886L315 885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M316 885L317 886L316 885M311 886L312 887L311 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M312 886L313 887L312 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M313 886L314 887L313 886z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide);
export default __webpack_public_path__ + "static/media/side.53a2b076f8348c928a4200f47b66c7ff.svg";
export { ForwardRef as ReactComponent };